import { Navigate, Outlet, useLocation } from "react-router-dom";

import { BugReportButton } from "@/components/common/bug-report-button";
import { UserFeedbackButton } from "@/components/common/user-feedback-button";
import { usePocketBase } from "@/context/pocketbase-context";

export const RequireAuth = () => {
  const { logout, user, token } = usePocketBase();
  const location = useLocation();

  // redirect user to login page if not authenticated
  if (!user) {
    console.warn("User not authenticated, redirecting to login");
    return (
      <Navigate to={{ pathname: "/login" }} state={{ location }} replace />
    );
  }

  // redirect user to login page if token is not available
  if (!token || token === "undefined") {
    return (
      <Navigate to={{ pathname: "/login" }} state={{ location }} replace />
    );
  }

  // Redirect user to login page if token is expired
  // This example assumes the token is a JWT and uses jwt-decode to parse it.
  if (token && typeof token === "string" && token.includes(".")) {
    try {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      const payload = JSON.parse(
        atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")),
      );
      console.log("Token payload:", payload);
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      if (payload.exp && Date.now() >= payload.exp * 1000) {
        console.warn("Token expired, redirecting to login");
        logout();
        return (
          <Navigate to={{ pathname: "/login" }} state={{ location }} replace />
        );
      }
    } catch (e) {
      console.warn("Error decoding token:", e);
      logout();
      return (
        <Navigate to={{ pathname: "/login" }} state={{ location }} replace />
      );
    }
  }

  // If all checks pass, render the Outlet component to display the child routes
  return (
    <>
      <Outlet />
      <div className="fixed left-5 md:left-20 bottom-4 md:bottom-8 md:bottom-10 z-20">
        <div className="flex flex-col gap-2" data-tour="send-comment-or-bug">
          <UserFeedbackButton />
          <BugReportButton />
        </div>
      </div>
    </>
  );
};
